import React, { useContext, useEffect, useMemo, useState } from "react";
import FetchContext from "../../contexts/fetch";
import FlowContext from "../../contexts/flowContext";
import SidebarContext from "../../contexts/sidebar";
import { DynamicFormUtilsDataContext } from "../DynamicForm";
import Edge from "./Edge";
import Flow from "./Flow";
import styles from "./manager.module.css";
import Node from "./Node";
import User from "./User";

const Manager = () => {
  // Sidebar context
  const [sidebarState] = useContext(SidebarContext);

  // flow context with all nodes and data
  const [flowState, flowDispatcher] = useContext(FlowContext);

  const [config] = useContext(FetchContext);

  // selected node data
  //const [nodeData, setNodeData] = useState(null)

  // selected edge data
  const [edgeData, setEdgeData] = useState(null);

  // data used by dynamic form
  const [dynamicFormUtilsData, setDynamicFormUtilsData] = useState({
    languages: [
      {
        value: "en",
        name: "Anglais",
      },
      {
        value: "fr",
        name: "Français",
      },
    ],
    codeContext: {
      meta_data: [
        "META_DATA_stage",
        "META_DATA_from",
        "META_DATA_call_sid",
        "META_DATA_s3_bucket_name",
        "META_DATA_brand",
        "META_DATA_state_name",
        "META_DATA_is_post",
        "META_DATA_host",
        "META_DATA_transcript",
      ],
    },
  });

  // Extract the data of the edge witch is selected
  useEffect(() => {
    if (
      flowState.edges &&
      flowState.edges.length > 0 &&
      !flowState.nodes.filter((node) => node.selected).length
    ) {
      const multipleEdgeSelection = flowState.edges.filter(
        (edge) => edge.selected
      );
      const selectedEdge =
        multipleEdgeSelection.length === 1 ? multipleEdgeSelection[0] : null;

      setEdgeData(selectedEdge ? selectedEdge : null);
    } else {
      setEdgeData(null);
    }
  }, [flowState.edges]);

  // update edge on the context if changed
  useEffect(() => {
    if (edgeData) {
      if (
        JSON.stringify(edgeData) !==
        JSON.stringify(flowState.edges.filter((edge) => edge.selected)[0])
      ) {
        flowDispatcher({
          type: "update-edge-data",
          value: {
            ...edgeData,
            //animated: true
          },
        });
      }
    }
  }, [edgeData, flowDispatcher]);

  const nodeDataBis = useMemo(() => {
    if (flowState.nodes && flowState.nodes.length > 0) {
      const multipleNodeSelection = flowState.nodes.filter(
        (node) => node.selected
      );
      const selectedNode =
        multipleNodeSelection.length === 1 ? multipleNodeSelection[0] : null;
      return selectedNode
        ? {
            id: selectedNode.id,
            ...selectedNode.data,
          }
        : null;
    } else {
      return null;
    }
  }, [flowState.nodes]);

  const clientConfig = useMemo(() => {
    return config.clientConfig || {};
  }, [config.clientConfig]);

  const handleModuleParamChange = function (parameters) {
    if (flowState.nodes && flowState.nodes.length > 0) {
      const multipleNodeSelection = flowState.nodes.filter(
        (node) => node.selected
      );
      const selectedNode =
        multipleNodeSelection.length === 1 ? multipleNodeSelection[0] : null;

      flowDispatcher({
        type: "update-node-parameters",
        id: selectedNode.id,
        parameters,
      });
    }
  };

  const handleModuleOptionChange = function (options) {
    const multipleNodeSelection = flowState.nodes.filter(
      (node) => node.selected
    );
    const selectedNode =
      multipleNodeSelection.length === 1 ? multipleNodeSelection[0] : null;

    flowDispatcher({
      type: "update-node-options",
      id: selectedNode.id,
      options,
    });
  };

  const handleNodeNameChange = function (name) {
    const multipleNodeSelection = flowState.nodes.filter(
      (node) => node.selected
    );
    const selectedNode =
      multipleNodeSelection.length === 1 ? multipleNodeSelection[0] : null;

    flowDispatcher({
      type: "update-node-name",
      id: selectedNode.id,
      name,
    });
  };

  const toggleEditing = function (e) {
    flowDispatcher({
      type:
        e.type === "focus"
          ? "enable-edition-in-progress"
          : "disable-edition-in-progress",
    });
  };

  const getFormUtilsContextValue = function () {
    let moduleOutput = [];
    const nodeType = nodeDataBis?.module.options.type;

    if (nodeType && nodeType !== "default") {
      moduleOutput = clientConfig.modules[nodeType]?.output || [];
    }

    return {
      ...dynamicFormUtilsData,
      codeContext: {
        ...dynamicFormUtilsData.codeContext,
        output: moduleOutput.map((name) => {
          return `OUTPUT_${name}`;
        }),
      },
    };
  };

  return (
    <div
      onFocus={toggleEditing}
      onBlur={toggleEditing}
      className={`${sidebarState.active ? styles.manager_active : ""} ${
        styles.manager
      }`}
    >
      <DynamicFormUtilsDataContext.Provider
        value={[getFormUtilsContextValue(), setDynamicFormUtilsData]}
      >
        {sidebarState.manager === "flow" ? (
          <Flow />
        ) : sidebarState.manager === "node" ? (
          <Node
            config={clientConfig}
            nodeData={nodeDataBis}
            onModuleParamChange={handleModuleParamChange}
            onModuleOptionChange={handleModuleOptionChange}
            onNodeNameChange={handleNodeNameChange}
          />
        ) : sidebarState.manager === "edge" ? (
          <Edge edgeData={edgeData} setEdgeData={setEdgeData} />
        ) : sidebarState.manager === "user" ? (
          <User />
        ) : null}
      </DynamicFormUtilsDataContext.Provider>
    </div>
  );
};

export default Manager;
